import { Modal } from "@portal/components/layout/Modal";
import { ModalContentWithScrollStatusMenu } from "@portal/components/layout/ModalContentWithScrollStatusMenu";
import { ModalItemWithHeader } from "@portal/components/layout/ModalItemWithHeader";
import { Button, Card, ClickableIcon, Text } from "@portal/components/primitives";

export const AdminSectionLayout = ({
	children,
	modal,
	header,
	isEditing,
	testId,
}: {
	children: React.ReactNode;
	header: React.ReactNode;
	modal: React.ReactNode;
	isEditing: boolean;
	testId?: string;
}) => {
	return (
		<Card elevation="raised" className="rounded-xl" data-testid={testId}>
			<Card.Body className="flex w-full flex-col p-6 space-y-5">
				{header}
				{children}
				{isEditing && <>{modal}</>}
			</Card.Body>
		</Card>
	);
};

export const AdminSectionHeaderLayout = ({
	label,
	toggleEditing,
}: {
	label: string;
	toggleEditing: () => void;
}) => {
	return (
		<div className="flex items-center justify-between w-full">
			<Text type="title" color="primary" className="flex-1">
				{label}
			</Text>
			<ClickableIcon type="pencil-square" size="mini" color="secondary" onClick={toggleEditing} />
		</div>
	);
};

export const AdminEditModalLayout = ({
	onClose,
	onSubmit,
	form,
	header,
	isLoading,
}: {
	onClose: () => void;
	onSubmit: () => void;
	header: React.ReactNode;
	form: React.ReactNode;
	isLoading: boolean;
}) => {
	return (
		<Modal onClickOutside={onClose}>
			<ModalItemWithHeader
				header={
					<Text type="title" color="primary">
						{header}
					</Text>
				}
				onClose={onClose}
				bodyClassName="w-[100vw] h-[90vh] sm:w-[80vw] md:w-full md:h-fit overflow-y-auto"
				className="h-fit overflow-hidden"
			>
				<ModalContentWithScrollStatusMenu
					buttons={
						<div className="w-full flex justify-center mt-[5px]">
							<Button
								onClick={onSubmit}
								color="primary"
								className="w-[150px]"
								tabIndex={2}
								loading={isLoading}
							>
								Submit
							</Button>
						</div>
					}
				>
					{form}
				</ModalContentWithScrollStatusMenu>
			</ModalItemWithHeader>
		</Modal>
	);
};
